// extracted by mini-css-extract-plugin
export default {"container":"report_container__PiZ3-"};